export enum SpaceSchemaVersion {
  V1 = '1.0.0',
  V2 = '2.0.0'
}
